import { jsx as _jsx } from "react/jsx-runtime";
import defaultBuildingImage from '@assets/images/default-building-image.png';
import BadgeSection from './BadgeSection';
import Overview from './Overview';
import { PropertyCardHeaderWrapper } from './Header.style';
const Header = ({ children, thumbnail }) => (_jsx(PropertyCardHeaderWrapper, { thumbnail: thumbnail || defaultBuildingImage, children: children }));
Header.BadgeSection = BadgeSection;
Header.Overview = Overview;
export default Header;
